import { IKnmPlanFilterRaw } from 'APIPackage/PlanListModule/interfaces/IKnmPlanFilterRaw';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IKnmPlanFilter } from 'PlanListPackage/PlanListFiltersModule/interfaces/IKnmPlanFilter';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';

import { planStatusesOptions } from '../constants/planStatusesOptions';
import { knmFilterFormBooleanSelectOptions } from '../../../KnmListPackage/KnmListPanelModule/constants/knmListFilterOptions';

export function mapRawToPlanFilter(
  raw: IKnmPlanFilterRaw,
  prosecutorOptions: IUserOrganisationSelectOption[],
  knoOptions: IUserOrganisationSelectOption[],
  planTypeOptions: ISelectOption[],
  planStatusOptions: ISelectOption<string>[],
): IKnmPlanFilter {
  return {
    ...raw,
    prosecutorOrganizationErvkUuids: raw.prosecutorOrganizationErvkUuids?.reduce((r, x) => {
      const prosecutor = prosecutorOptions.find(proc => x.toString() === proc.id);

      return prosecutor ? [...r, prosecutor] : [];
    }, []),
    knoIds:
      raw.knoIds?.reduce((r, x) => {
        const kno = knoOptions.find(k => x.toString() === k.id);

        return kno ? [...r, kno] : [...r];
      }, []) ?? [],
    types: raw.types?.reduce((r, x) => {
      const type = planTypeOptions.find(t => x === t.value);

      return type ? [...r, type] : [...r];
    }, []),
    statuses: raw.statuses?.reduce((r, x) => {
      const status = planStatusesOptions.find(s => s.id === x.toString());

      return status ? [...r, status] : [...r];
    }, []),
    erknmStatuses: raw.erknmStatuses?.reduce((r, x) => {
      const status = planStatusOptions.find(s => s.id === x.toString());

      return status ? [...r, status] : [...r];
    }, []),
    startDate: raw.startDate ? formatDate({ date: raw.startDate, dateFormat: DATE_FORMAT_LONG_FNS }) : '',
    endDate: raw.endDate ? formatDate({ date: raw.endDate, dateFormat: DATE_FORMAT_LONG_FNS }) : '',
    isTest: raw.isTest ? knmFilterFormBooleanSelectOptions.find(i => i.value === raw.isTest) : undefined,
  };
}
